import React from 'react';

const Help = () => {
    return (
        <div className="space-y-6">
            <div className="border-b pb-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">User Management</h3>
                <p className="text-sm text-gray-600">
                    Manage team members, drivers, and administrators within your fleet workspace.
                </p>
            </div>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Adding Team Members</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Click <strong>Add User</strong> to invite a new person to your account.</li>
                    <li>Enter their <strong>Name</strong>, <strong>Email</strong>, and assign a <strong>Role</strong>.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Roles and Permissions</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li><strong>Admin:</strong> Full access to all modules and settings.</li>
                    <li><strong>Manager:</strong> Can manage fleet operations but may have limited settings access.</li>
                    <li><strong>Driver:</strong> Access to logging fuel and service but limited reporting access.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Status Tracking</h4>
                <p className="text-sm text-gray-600">
                    Monitor user <strong>Status</strong> (e.g., Active, Suspended) to control access to your fleet data.
                </p>
            </section>
        </div>
    );
};

export default Help;
